import React, { useState, createContext, useContext } from "react";
import styles from "./GlobalLoader.module.css";

const LoaderContext = createContext();

export const useLoader = () => useContext(LoaderContext);

export const GlobalLoaderProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const showLoader = () => setIsLoading(true);
  const hideLoader = () => setIsLoading(false);

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader }}>
      {children}
      {isLoading && (
        <div className={styles.backdrop}>
          <div className={styles.loader}></div>
        </div>
      )}
    </LoaderContext.Provider>
  );
};
